/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierInsControl.ts             *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/powerbroker/carrier-ins-control";

export class AutogenModelCarrierInsControl<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierInsControlFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierInsControl extends ModelRow<RowCarrierInsControlFields> {
	constructor(values?: Partial<RowCarrierInsControlFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierInsControlFields {
	account_id: string;
	account_password: string;
	account_type: string;
	advance_enabled: string;
	auto_approve: string;
	auto_ins_on_file: string;
	c411_auth_date: Date;
	c411_safestat_date: Date;
	c411_safety_date: Date;
	cacci_last_run: Date;
	carrier_agreement: string;
	company_id: string;
	document_server: string;
	error_email: string;
	exclude_contacts: string;
	exclude_equipment_types: string;
	exclude_pnn_lanes: string;
	ftp_password: string;
	ftp_port: number;
	ftp_server: string;
	ftp_user_id: string;
	highway_api_key: string;
	id: string;
	image_directory: string;
	include_inactive_carriers: string;
	integration_id: number;
	is_active: string;
	last_full_sync_date: Date;
	last_onboarding_check: Date;
	last_page_processed: number;
	last_sync_date: Date;
	latest_load_data_sync: Date;
	logo: string;
	logo_name: string;
	monitor_onboarded_carriers: string;
	onboarding_ins_basic: string;
	onboarding_password: string;
	onboarding_server: string;
	onboarding_username: string;
	onboarding_version: number;
	packet_url: string;
	packet_website_url: string;
	payee_status_new: string;
	port: number;
	proxy_server: string;
	remote_directory: string;
	saferwatch_last_update: Date;
	saferwatch_service_key: string;
	send_carriers: string;
	send_load_data: string;
	send_load_data_frequency: number;
	server: string;
	session_date: Date;
	session_expire_date: Date;
	session_uuid: string;
	sftp_delta_retrieval: string;
	show_observed_lanes: string;
	show_watchdog_rpt_status: string;
	sync_by_dot: string;
	unload_file: string;
	update_ins_date: string;
	use_delta_api: string;
	vendor_id: string;
}

